export const timestampMaskFormat = {
  '5': /[0-5]/,
  '9': /[0-9]/
};